(function() {
	
	CONFIGURATION_NOT_AVAILABLE_MESSAGE = 'Product is not available with the selected options';

	var configKey = function(attrs) {
		var key = [];
		for(var k in attrs) {
			key.push(k + '=' + attrs[k]);
		}
		return $.uniqueSort(key).join('|');
	};

	/**
	 * Product details page
	 */
	var ProductPage = function(params) {
		var self = this;
		this.validConfig = true;
		this.validCustomizations = true;
		this.pricePrecision = params.pricePrecision
		this.prices = $("#product_prices").data("prices") || [];
		this.primaryQuantityInput = $("#primary_add_to_cart #primary-add-to-cart-quantity");
		this.min_price = parseMoney(this.primaryQuantityInput.data("min-price"));
		this.max_price = parseMoney(this.primaryQuantityInput.data("max-price"));
		this.quantity = parseMoney(this.primaryQuantityInput.val());
		this.productPurchasble = this.primaryQuantityInput.length > 0;

		$("#primary_add_to_cart").on('submit', function (e) {
			// Update hidden inputs for product customizations
			$(".customization-field").each(function () {
				var id = $(this).data('id')
				$("#primary_add_to_cart #product_customization_" + id + "_id").val(id);
				$("#primary_add_to_cart #product_customization_" + id + "_value").val($(this).val());
				$("#primary_add_to_cart #product_customization_" + id + "_label").val($(this).data('label'));
				$("#primary_add_to_cart #product_customization_" + id + "_price").val($(this).data('price') || 0);
			});
		});
		
		this.primaryQuantityInput.on('input', function () {
			self._updatePrices();
		});
		
		this.initAddToCart();
		this.initGroupings();
		this.initConfigurable();
		this.initCustomization();
		this.initImages();
		this.initThumbnails();
	};

	ProductPage.prototype = {
		// Init jquery-zoom for product image
		initZoom: function(url) {
			$('#imageDialog #imageDisplay').trigger('zoom.destroy');
			var zoomUrl = url;
			var zoomImg = new Image();
			zoomImg.src = zoomUrl;

			$('#imageDialog #imageDisplay').zoom({
				url: zoomUrl
			});
		},
		
		initImages: function() {
			var self = this;
			
			$('#product_image').on('click', function(e) {
				self.prepareImageModal($(this).data('zoom-url'))
				$('#imageDialog').modal('show');
			});

			$('#imageDialog .arrow-cell-left').click(self.prevImage.bind(self));
			$('#imageDialog .arrow-cell-right').click(self.nextImage.bind(self));

			$('#imageDialog').keydown(function (e) {
				if (e.keyCode == 37) { // left
					self.prevImage();
				} else if (e.keyCode == 39) { // right
					self.nextImage();
				}
			});

		},

		prevImage: function() {
			var prevIndex = this.currentIndex - 1
			if (prevIndex >= 0) {
				this._imageChange(prevIndex)
				this.prepareImageModal(this.images[prevIndex].zoomUrl);
			}
		},

		nextImage: function() {
			var nextIndex = this.currentIndex + 1
			if (nextIndex <= this.images.length - 1) {
				this._imageChange(nextIndex)
				this.prepareImageModal(this.images[nextIndex].zoomUrl);
			}
		},

		prepareImageModal: function(imageUrl) {
			$('#imageDialog #imageDisplay img').attr('src', imageUrl);
			this.initZoom(imageUrl);
		},
		
		initThumbnails: function() {
			var self = this;
			this.images = [];
			this.currentIndex = 0;

			// Populate this.images
			$('#thumbnails .product-thumbnail-wrapper').each(function() {
				self.images.push({
					imageUrl: $(this).data('proxy-url'),
					zoomUrl: $(this).data('zoom-url'),
					srcset: $(this).data('srcset')
				});
			});

			$('#thumbnails .product-thumbnail').first().addClass('selected');
			$('#thumbnails .product-thumbnail').on('click', function() {
				var wrapper = $(this).closest('.product-thumbnail-wrapper');
				self._imageChange(wrapper.data('index'));
			});
		},

		_imageChange: function (index) {
			this.currentIndex = index;
			var imageData = this.images[index];
			$('#product_image').data('index', index);
			$('#product_image').data('zoom-url', imageData.zoomUrl);
			$('#product_image .product-image').attr('src', imageData.imageUrl);
			$('#product_image .product-image').attr('srcset', imageData.srcset);
			$('#thumbnails .product-thumbnail').removeClass('selected');
			$("#thumbnails .product-thumbnail-wrapper[data-index='" + index + "'] .product-thumbnail").addClass('selected');
		},
		
		// Add To Cart Dialog
		initAddToCart: function() {
			$('form.product-add-to-cart-form').each(function(i, elem) {
				new C.AddToCart(elem);
			});
		},
		
		// Initialize configurable products
		initConfigurable: function() {
			var container = $('#product_config');
			if(!container.length) return; // Not a configurable product
			this.validConfig = false;
			var configurations = container.data('configurations');
			var fields = container.data('fields');
			
			// Create a lookup hash for quickly finding a product for the selected options
			var configLookup = {};
			for(var i = 0; i < configurations.length; i++) {
				configLookup[configKey(configurations[i].options)] = configurations[i].id;
			}

			// Set the product id to blank because the parent product can't be purchased
			$('#product_id').val('');

			// Listen for changes to the configuration dropdowns
			var configDropdowns = $('.product-config select.config-option');
			var self = this;
			configDropdowns.on('change', function(evt, e) {
				self._configChange(configLookup, configDropdowns);
			});
			
			// Initialize the state of the pricing/images
			this._configChange(configLookup, configDropdowns);
		},
		
		_configChange: function(configLookup, configDropdowns) {
			this.productPrice = undefined;

			// Collect all the option attributes and determine
			// if all dropdowns have a value selected (not the "Choose an option..." option)
			var attrs = {}, allSelected = true;
			configDropdowns.each(function(i, elem) {
				attrs[$(elem).attr('name')] = $(elem).val();
				if($(elem).prop('selectedIndex') == 0) {
					allSelected = false;
				}
			});

			// Update product data on the page based on the parent product if
			// a valid configuration is not selected
			var childId = configLookup[configKey(attrs)];
			var configElem = $(childId ? ('#child_product_' + childId) : '#parent_product');
			
			// Update the product image and add to cart product id
			$('#product_id').val(childId ? childId : '');
			$('#product_image').html(configElem.find('.image').html());
			$('#tiered_pricing').html(configElem.find('.tiered-pricing').html());
			$('#thumbnails').html(configElem.find('.thumbnails').html());
			this.initThumbnails();
			
			// Set up zoom for new image
			$('#product_image').data("zoom-url", configElem.find('.image').data("zoom-url"))
			
			// Update the product price
			if (childId) {
				$('#product_price').html(configElem.find('.price').html());
				// Update the product price when a config product price is shown
				this.productPrice = parseMoney(configElem.find('.price .amount').html());
				this._updatePrices();
			} else if (allSelected) {
				$('#product_price').html(CONFIGURATION_NOT_AVAILABLE_MESSAGE);
			} else {
				// At least one config dropdown does not have an option selected -- show parent price
				$('#product_price').html(configElem.find('.price').html());
			}

			this.validConfig = !(!childId)
			this._updateButtons();
		},
		
		initCustomization: function() {
			var container = $('#product_customizations');
			if(!container.length) return; // No product customizations
			this.validCustomizations = false;
			
			// Clear out customization fields after add to cart
			$('#add_to_cart_dialog').on('hide.bs.modal', function() {
				$('#product_customizations .customization-field').val('');
			});

			this.customizationPrices = {};
			var self = this;
			container.find($(".customization-field")).each(function() {
				self.customizationPrices[$(this).data("id")] = parseMoney($(this).data("price")) || 0
			})
			
			// Listen for changes to the custom fields
			$('.product_customizations .customization-field').on('input', function(evt, e) {
				self._customizationChange();
			});

			this._customizationChange();
		},
		
		_customizationChange: function() {
			this._updatePrices();
			
			var blanks = $('.product_customizations .customization-field.required').filter(function() {
				return this.value.trim() === '';
			})
			this.validCustomizations = (blanks.length === 0)
			this._updateButtons();
		},
		
		initGroupings: function() {
			var container = $('#grouped-products');
			if(!container.length) return; // No grouped products
			
			this.groupingsPrices = {};
			var self = this;
			container.find($(".grouped-product-price")).each(function() {
				self.groupingsPrices[$(this).data("id")] = $(this).data('prices')
			});

			// Update bound quantity products when main quantity input changes
			if ($("#grouped-products .grouped-product-quantity.bind-quantity").length) {
				var tooltip = "Must be the same as parent product or 0"
				$("#grouped-products .grouped-product-quantity.bind-quantity").tooltip({ 'trigger': 'focus', 'title': tooltip, 'placement': 'bottom' });
				$("#primary_add_to_cart #primary-add-to-cart-quantity").on('input', function () {
					$("#grouped-products .bind-quantity").filter(function (i) {
						var id = $(this).data('id')

						// Don't update quantity for no-price groupings 
						if (self.groupingsPrices[id] && self.groupingsPrices[id].length == 0) {
							return false
						}

						// Don't update products that aren't required and have quantity set to < 0
						var curr_qty = parseMoney($(this).val());
						if (isNaN(curr_qty) || curr_qty > 0 || $(this).hasClass('required')) {
							return true;
						}
					}).val($(this).val());
					self._groupingsChange();
				});
			}
			
			// Listen for changes to grouped products quantity inputs
			$('#grouped-products .grouped-product-quantity').on('input', function(evt, e) {
				self._groupingsChange();
			});

			this._groupingsChange();
		},
		
		_groupingsChange: function() {
			// Disable add to cart for list grouped products if no child items have a quantity entered
			if ($('#grouped-products').data('grouping-type') == 'list') {
				var hasChildWithQuantity = false;
				$('#grouped-products .grouped-product-quantity').each(function() {
					if (!!$(this).val()) hasChildWithQuantity = true
				});
				$('#primary_add_to_cart .product-add-to-cart').prop('disabled', !hasChildWithQuantity);
			}

			this._updateGroupedProductTotals();
			if (this.productPurchasble) {
				this._updatePrices();
			} else {
				this._updateGrandTotal();
			}
		},

		_updateGroupedProductTotals: function() {
			var self = this;
			this.groupingsTotal = 0;
			$('#grouped-products tbody tr').each(function () {
				var id = $(this).find('.grouped-product-price').data('id');
				var quantity = $(this).find('.grouped-product-quantity').val();
				var unitPrice = self._getPriceFromQuantity(quantity, self.groupingsPrices[id]);
				var showRange = !quantity || !unitPrice;
				var priceDisplay = null, totalDisplay = null, groupedItemTotal = 0;

				if (self.groupingsPrices[id].length == 0) {
					priceDisplay = 'None'
					totalDisplay = 'None'
				} else if (showRange) {
					var minPriceStr = self.groupingsPrices[id].reduce(function (prev, curr) {
						return parseFloat(prev.price) < parseFloat(curr.price) ? prev : curr
					}).price
					var maxPriceStr = self.groupingsPrices[id].reduce(function (prev, curr) {
						return parseFloat(prev.price) > parseFloat(curr.price) ? prev : curr
					}).price

					var min = parseFloat(minPriceStr)
					var max = parseFloat(maxPriceStr)
					var priceRangeDisplay = self.priceWithCurrency(min) + " - " + self.priceWithCurrency(max);
					if (min === max) {
						priceRangeDisplay = self.priceWithCurrency(min);
					}

					priceDisplay = priceRangeDisplay;
					totalDisplay = priceRangeDisplay;
				} else {
					groupedItemTotal = unitPrice * quantity;
					priceDisplay = self.priceWithCurrency(parseFloat(unitPrice));
					totalDisplay = self.priceWithCurrency(parseFloat(groupedItemTotal));
					self.groupingsTotal += groupedItemTotal;
				}

				$(this).find('.grouped-product-price').html(priceDisplay);
				$(this).find('.grouped-product-total .price-display').html(totalDisplay);
			});
		},

		_updatePrices: function() {
			this._updateItemPrice();
			this._updateGrandTotal();
		},
		
		// Calculate and display item price (item unit price = product price + customizations price)
		_updateItemPrice: function() {
			this.quantity = parseMoney(this.primaryQuantityInput.val());
			var pp = this._getPriceFromQuantity(this.quantity, this.prices);
			if (pp != undefined && pp != null) this.productPrice = pp

			if (!this.quantity) {
				this._showPriceRange();
				return;
			}

			if (this.productPrice != null) {
				this.itemPrice = this.productPrice + this._getCustomizationsCost();
				$("#product_price .price-display").html(this.priceWithCurrency(this.itemPrice));
			}
		},

		_updateGrandTotal: function() {
			var grandTotal = this.groupingsTotal;
			if (this.productPurchasble) {
				grandTotal += (this.itemPrice * this.quantity);
			}

			if (!isNaN(grandTotal)) {
				$("#product-grand-total .price-display").html(this.priceWithCurrency(grandTotal));
			}
		},

		// For tiered pricing. Find the price given a quantity and prices array
		_getPriceFromQuantity: function (quantity, prices) {
			var min_diff = null, price = null, diff = null;
			for (var i = 0; i < prices.length; i++) {
				var price_min_quantity = parseMoney(prices[i].min_quantity);
				if (price_min_quantity <= quantity) {
					diff = quantity - price_min_quantity;
					if (min_diff === null) {
						price = prices[i].price;
						min_diff = diff;
					} else if (quantity - price_min_quantity < min_diff) {
						price = prices[i].price;
						min_diff = diff;
					}
				}
			}

			if (price != null) {
				return parseMoney(price);
			}
		},
		
		_getCustomizationsCost: function() {
			var customizationsCost = 0;
			var self = this;
			
			// Add price for each present customization
			if ($('#product_customizations').length) {
				// Get array of ids of the present customizations
				var present = $('.product_customizations .customization-field').filter(function() {
					return this.value != '';
				}).map(function() {
					return $(this).data('id');
				})

				present.each(function() {
					customizationsCost += self.customizationPrices[this];
				})
			}
			
			return customizationsCost;
		},
		
		_updateButtons: function() {
			var addToCartButton = $('#primary_add_to_cart .product-add-to-cart');
			var addToLinks = $('.add-to-links a');
			var addToButtons = $('.add-to-links button');

			addToCartButton.prop('disabled', !(this.validConfig && this.validCustomizations));

			if (this.validConfig && this.validCustomizations) {
				addToLinks.attr('data-toggle', 'modal');
				addToLinks.removeClass('disabled');
				addToButtons.prop('disabled', false)
				addToButtons.removeClass('disabled');
			} else {
				addToLinks.removeAttr('data-toggle');
				addToLinks.addClass('disabled')
				addToButtons.prop('disabled', true)
				addToButtons.addClass('disabled');
			}
		},
		
		_showPriceRange: function() {
			if (this.prices.length == 1) {
				$("#product_price .price-display").html(this.priceWithCurrency(parseMoney(this.prices[0].price)));
			} else if (this.min_price === this.max_price) {
				$("#product_price .price-display").html(this.priceWithCurrency(this.min_price));
			} else {
				var min = this.priceWithCurrency(this.min_price);
				var max = this.priceWithCurrency(this.max_price);
				$("#product_price .price-display").html(min + " - " + max);
			}
		},

		priceWithCurrency: function(price) {
			var currency_element =  $("#product_price .currency").first();
			var currency = currency_element.html();
			var currency = currency || '$';
			// Display price with commas and two decimals
			price = price.toFixed(this.pricePrecision).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			var html =  "<span class='amount'>" + price + "</span>";
			if (currency_element.hasClass("after")) {
				var currency_html = "<span class='currency after'>" + currency + "</span>";
				html += " " + currency_html;
			} else {
				var currency_html = "<span class='currency'>" + currency + "</span>"
				html = currency_html + html;
			}
			return html;
		}
	};

	C.ProductPage = ProductPage;

})();
